// Service worker registration & lifecycle helpers for the PWA build.
// Loaded from src/index.js. Safe no-op in development if /service-worker.js is not present.

export function registerPWA() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch((err) => {
      if (process.env.NODE_ENV !== "production") {
        console.warn("[PWA] Service worker registration failed:", err);
      }
    });
  });
}
